import { createContext, MutableRefObject, useContext } from "react";

export const ContainerContext = createContext<MutableRefObject<HTMLDivElement>>(
  {} as any
);

export const useContainer = () => {
  return useContext(ContainerContext);
};
